export const ENVIRONMENT_STRATEGY_ERROR = 'You can not enable the environment before it has strategies';
